import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        flex: isWeb ? undefined : 1,
        height: 48,
        justifyContent: 'center',
    },
    title: {
        marginLeft: 16,
        color: COLOR.WHITE_OVERLAY(0.7),
        fontFamily: Fonts.main.regular,
        fontSize: 16,
    },
    selectedItem: {
        backgroundColor: COLOR.primary,
    },
    selectedTitle: {
        color: COLOR.background,
        fontFamily: Fonts.main.bold,
        fontSize: 16,
    },
    checkMark: {
        position: 'absolute',
        right: 14,
        alignSelf: 'center',
    },
});

export default styles;
